module.exports = __webpack_public_path__ + "static/media/clip.4bbeef80.png";